import { render, staticRenderFns } from "./OrderReadyForDispatchDialogue.vue?vue&type=template&id=2a17cab4&"
import script from "./OrderReadyForDispatchDialogue.vue?vue&type=script&lang=ts&"
export * from "./OrderReadyForDispatchDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports